module.exports = __webpack_public_path__ + "img/EAT.4fe988f1.png";